class RefiContactHours extends HTMLElement {
  connectedCallback() {
    this.innerHTML = 'Mon-Fri 9 am – 9 pm ET';
  }
}

export { RefiContactHours };
